"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var loadSegments = function loadSegments(params) {
  return {
    type: 'OLY_LOAD_SEGMENTS',
    payload: _objectSpread({}, params)
  };
};

var loadSegmentsSuccess = function loadSegmentsSuccess(payload) {
  return {
    type: 'OLY_LOAD_SEGMENTS_SUCCESS',
    payload: payload
  };
};

var loadSegmentsError = function loadSegmentsError() {
  return {
    type: 'OLY_LOAD_SEGMENTS_ERROR'
  };
};

var createSegment = function createSegment(params) {
  return {
    type: 'OLY_CREATE_SEGMENT',
    payload: _objectSpread({}, params)
  };
};

var createSegmentSuccess = function createSegmentSuccess() {
  return {
    type: 'OLY_CREATE_SEGMENT_SUCCESS'
  };
};

var createSegmentError = function createSegmentError() {
  return {
    type: 'OLY_CREATE_SEGMENT_ERROR'
  };
};

var updateSegment = function updateSegment(params) {
  return {
    type: 'OLY_UPDATE_SEGMENT',
    payload: _objectSpread({}, params)
  };
};

var updateSegmentSuccess = function updateSegmentSuccess(updatedSegment) {
  return {
    type: 'OLY_UPDATE_SEGMENT_SUCCESS',
    payload: {
      data: updatedSegment
    }
  };
};

var updateSegmentError = function updateSegmentError() {
  return {
    type: 'OLY_UPDATE_SEGMENT_ERROR'
  };
};

var deleteSegment = function deleteSegment(params) {
  return {
    type: 'OLY_DELETE_SEGMENT',
    payload: _objectSpread({}, params)
  };
};

var deleteSegmentSuccess = function deleteSegmentSuccess() {
  return {
    type: 'OLY_DELETE_SEGMENT_SUCCESS'
  };
};

var deleteSegmentError = function deleteSegmentError() {
  return {
    type: 'OLY_DELETE_SEGMENT_ERROR'
  };
};

var isLoading = function isLoading(payload) {
  return {
    type: 'OLY_IS_SEGMENT_LOADING',
    payload: payload
  };
};

var resetSegmentsError = function resetSegmentsError() {
  return {
    type: 'OLY_RESET_SEGMENT_ERROR'
  };
};

var resetHasBeenCreated = function resetHasBeenCreated() {
  return {
    type: 'OLY_RESET_SEGMENT_HAS_BEEN_CREATED'
  };
};

var resetHasBeenUpdated = function resetHasBeenUpdated() {
  return {
    type: 'OLY_RESET_SEGMENT_HAS_BEEN_UPDATED'
  };
};

var resetSegments = function resetSegments() {
  return {
    type: 'OLY_RESET_SEGMENTS'
  };
};

var _default = {
  loadSegments: loadSegments,
  loadSegmentsSuccess: loadSegmentsSuccess,
  loadSegmentsError: loadSegmentsError,
  createSegment: createSegment,
  createSegmentSuccess: createSegmentSuccess,
  createSegmentError: createSegmentError,
  updateSegment: updateSegment,
  updateSegmentSuccess: updateSegmentSuccess,
  updateSegmentError: updateSegmentError,
  deleteSegment: deleteSegment,
  deleteSegmentSuccess: deleteSegmentSuccess,
  deleteSegmentError: deleteSegmentError,
  isLoading: isLoading,
  resetSegments: resetSegments,
  resetSegmentsError: resetSegmentsError,
  resetHasBeenCreated: resetHasBeenCreated,
  resetHasBeenUpdated: resetHasBeenUpdated
};
exports["default"] = _default;
//# sourceMappingURL=actions.js.map